module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaAQMAAACThN6NAAAABlBMVEUAAAAaGhr5mZzIAAAAPElEQVQI12NgwAWYGAQYGNgZLBgYmBsKGBgYDzwACj48ACSKG4CEPUiNHJwAc8ESICVgxWBtYAPARuECAPeMC60UQDgmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/floor9/close.png
// module id = OMtP
// module chunks = 2